import { render, staticRenderFns } from "./StatOverview.vue?vue&type=template&id=ebc9bdee&scoped=true"
import script from "./StatOverview.vue?vue&type=script&lang=js"
export * from "./StatOverview.vue?vue&type=script&lang=js"
import style0 from "./StatOverview.vue?vue&type=style&index=0&id=ebc9bdee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc9bdee",
  null
  
)

export default component.exports